import styled from 'styled-components';

import { Card } from '@savgroup-front-common/core/src/atoms/Cards';

import { dossierResponsiveMediaQuery } from '../../pages/DossierPage.styles';

export const $BlockCard = styled(Card)`
  margin-bottom: 1rem;
  overflow: hidden;

  @media ${dossierResponsiveMediaQuery} {
    width: calc(100% + 2rem);
    max-width: none;
    margin-left: -1rem;
    margin-right: -1rem;
    margin-bottom: 1rem;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
`;

export const $StatesHeader = styled.div`
  display: flex;
  width: 100%;

  @media ${dossierResponsiveMediaQuery} {
    display: none;
  }
`;

export const $AccordionList = styled.div`
  display: none;

  @media ${dossierResponsiveMediaQuery} {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const $AccordionItem = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#e5e7eb'};

  &:last-child {
    border-bottom: none;
  }
`;

export const $StateSelector = styled.button<{
  $isActive: boolean;
  $hasOneAction: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  width: 100%;
  padding: 1rem;
  border: none;
  text-align: left;
  cursor: ${({ $hasOneAction }) => ($hasOneAction ? 'default' : 'pointer')};
  background-color: ${({ theme, $isActive }) =>
    $isActive
      ? theme.newUI?.variationColors?.light5 ?? theme.colors.white
      : theme.newUI?.variationColors?.light7 ?? theme.colors.lightGrey};

  &:hover {
    background-color: ${({ theme, $isActive, $hasOneAction }) => {
      if ($hasOneAction) {
        return undefined;
      }

      if ($isActive) {
        return theme.newUI?.variationColors?.light5 ?? theme.colors.white;
      }

      return theme.newUI?.variationColors?.light6 ?? theme.colors.lightGrey;
    }};
  }
`;

export const $AccordionHeader = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 1rem;
  border: none;
  text-align: left;
  cursor: pointer;
  background-color: ${({ theme, $isOpen }) =>
    $isOpen
      ? theme.newUI?.variationColors?.light5 ?? theme.colors.white
      : theme.newUI?.variationColors?.light7 ?? theme.colors.lightGrey};
`;

export const $AccordionHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  min-width: 0;
  flex: 1;
`;

export const $AccordionChevron = styled.span<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.15rem;
  transition: transform 150ms ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const $StateDate = styled.div`
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const $StateTitle = styled.div`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.mainTextColor};
  font-size: ${({ theme }) => theme.fonts.size.medium};
  line-height: 1.3;
`;

export const $StateLabel = styled.div`
  margin-top: 0.25rem;
  font-size: ${({ theme }) => theme.fonts.size.small};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  color: ${({ theme }) => theme.colors.secondaryTextColor};
`;

export const $ChoicesSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem 1rem;

  @media ${dossierResponsiveMediaQuery} {
    padding: 1rem 1rem 1rem;
  }
`;

export const $DesktopChoices = styled.div`
  @media ${dossierResponsiveMediaQuery} {
    display: none;
  }
`;

export const $FormBody = styled.div`
  margin-bottom: 1rem;
`;

export const $TransitionsList = styled.div`
  width: 100%;

  & > div {
    width: 100%;
  }

  label {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
`;

export const $ActionsContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 1.5rem 0 0;
  justify-content: flex-end;

  @media ${dossierResponsiveMediaQuery} {
    justify-content: stretch;

    button {
      flex: 1;
    }
  }
`;

export const $ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;

  @media ${dossierResponsiveMediaQuery} {
    width: 100%;
    flex-direction: column;
  }
`;

export const $EmptyState = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fonts.size.small};
  color: ${({ theme }) => theme.colors.secondaryTextColor};
`;
